module.exports = __webpack_public_path__ + "static/media/18ECA22.cba38fef.jpg";